import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    getConfigurationData,
    getDocumentMetaWithDocId,
    getLockDocuments,
} from '../api/api';
import PdfPreview from '../../components/pdfpreview/PdfPreview';
import { ThemeContext } from '../inbox/InboxPage';

const DocumentHandle = () => {
    const pdfPrintRef = useRef(null);
    const { documentId } = useParams();

    const [isLocked, setIsLocked] = useState(false);
    const [documentFields, setDocumentFields] = useState([]);

    useEffect(() => {
        const fetchDocumentData = async () => {
            try {
                setDocumentFields({});
                const response = await getDocumentMetaWithDocId({
                    docid: documentId,
                });

                const configuration = getConfigurationData();
                const mappedFields = {};

                response?.fields?.forEach((field) => {
                    const { fieldId, value } = field;
                    for (const key in configuration) {
                        if (configuration[key].fieldId === fieldId) {
                            mappedFields[configuration[key].name] = value;
                            break;
                        }
                    }
                });

                setDocumentFields(mappedFields);
            } catch (error) {
                console.error('Error fetching document data:', error);
            }
        };

        fetchDocumentData();
    }, [documentId]);

    const getLockedDocuments = async () => {
        try {
            const response = await getLockDocuments();
            const lockedDocIds = response.map((item) => item.itemNum);
            setIsLocked(lockedDocIds.includes(documentId));
        } catch (error) {
            console.error('Error fetching locked document IDs:', error);
        }
    };

    useEffect(() => {
        getLockedDocuments();
    }, [documentId]);

    const renderField = (label, value) => (
        <div className='col-lg-4'>
            <span className='patient_label'>{label}</span>
            <br />
            <span className='patient_info'>{value || '-'}</span>
        </div>
    );

    const renderGroupedFields = (fields) => {
        const groupedFields = [];
        const fieldEntries = Object.entries(fields);
        for (let i = 0; i < fieldEntries.length; i += 3) {
            groupedFields.push(fieldEntries.slice(i, i + 3));
        }
        return groupedFields.map((group, index) => (
            <div key={index} className='form-group patient_detail row'>
                {group.map(([key, value]) => renderField(key, value))}
            </div>
        ));
    };

    return (
        <ThemeContext.Provider value={{ name: 'inbox' }}>
            <div>
                <div
                    id='left-aside'
                    className={`left-aside py-5 rounded-lg aside-fixed flex-row-auto aside-small-view`}
                    style={{ width: '45%' }}
                >
                    <PdfPreview
                        ref={pdfPrintRef}
                        docId={documentId}
                        isLocked={isLocked}
                        updateParent={getLockedDocuments}
                        key={documentId}
                    />
                </div>

                <div
                    id='left-last-aside'
                    className={`left-aside rounded-lg aside-fixed flex-row-auto expand-mode`}
                    style={{ width: '50%' }}
                >
                    <div className='details_part mb-10'>
                        <div className='details_fun'>
                            <span>
                                <i
                                    title='Details'
                                    className='fa-solid fa-notes-medical'
                                >
                                    {' '}
                                </i>
                                Details
                            </span>
                        </div>
                    </div>

                    {documentFields && renderGroupedFields(documentFields)}
                </div>
            </div>
        </ThemeContext.Provider>
    );
};

export default DocumentHandle;
